const { validator, validComparableTypes } = require('./utils/validation');

module.exports = {
  test({ params, rule }) {

    if (!params.hasOwnProperty(rule.arrayName)) {
      return false
    }

    const paramsArray = params[rule.arrayName];

    if (!Array.isArray(paramsArray)) {
      return false
    }

    return paramsArray.includes(rule.element);
  },

  validate: validator({
    'Rule must have a `arrayName` property': rule => 'arrayName' in rule,
    "Rule's `arrayName` property must be a string": rule => typeof rule.arrayName === 'string',
    'Rule must have a `element` property': rule => 'element' in rule,
    'Rule element must be a string, number, or boolean': rule => validComparableTypes.has(typeof rule.element)
  })
};
